  
import React, { useEffect, useState } from 'react';
import '../style/Header.scss';
function Header() {
  return (
    <>
    <div className="header">
        <div className="header-title-text">Navbar</div>
    </div>
    <div className="App-header-margin"></div>
    </>
  );
}

export default Header;
